import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    stake: 'Stake',
    staking: 'Staking',
    unstake: 'Unstake',
    unstaking: 'Unstaking',
    amount: 'Amount',
    balance: 'Balance: {value} {token}',
    max: 'MAX',
    youWillGet: 'You will get',
    exchangeRate: 'Exchange rate',
    rate: '1 {nativeToken} = {value} {token}',
    transactionFee: 'Transaction fee',
    yearly: 'Yearly est. earnings',
    enterAmount: 'Enter Amount',
  },
};
